import React from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Button } from 'antd';
import { FileExcelOutlined } from "@ant-design/icons";

import logoARN from '../../assets/logos/Banner_Logos_FRES.png';

const ExportExcelComponent = ({ jsonData, codigoInterno }) => {

    // 🟢 Función para calcular los totales y el porcentaje de avance general
    const calculateOverallProgress = (data) => {
        let totalProyectadas = 0;
        let totalEjecutadas = 0;

        const traverse = (nodes) => {
            nodes.forEach(node => {
                if (node.isFinal === "yes") {
                    totalProyectadas += parseInt(node.noDeActividades || 0, 10);
                    totalEjecutadas += parseInt(node.noDeEjecutados || 0, 10);
                }
                if (node.children && node.children.length > 0) {
                    traverse(node.children);
                }
            });
        };

        // 🟢 Recorre todo el JSON
        traverse(data);

        // 🔥 Calcular porcentaje de avance
        let porcentajeAvance = totalProyectadas > 0 ? ((totalEjecutadas / totalProyectadas) * 100).toFixed(2) : "0.00";

        return {
            totalProyectadas,
            totalEjecutadas,
            porcentajeAvance
        };
    };

    // 🟢 Obtener datos del avance general a partir de jsonData
    const { totalProyectadas, totalEjecutadas, porcentajeAvance } = calculateOverallProgress(jsonData);



    const exportToExcel = async () => {
        if (!Array.isArray(jsonData) || jsonData.length === 0) {
            alert("No hay datos para exportar.");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Plan Operativo');

        // ✅ Convertir imagen a Base64 manualmente desde una URL local
        const imgToBase64 = (imagePath) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = "Anonymous";
                img.src = imagePath;
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    resolve(canvas.toDataURL("image/png").split(",")[1]); // Solo Base64 sin encabezado
                };
                img.onerror = (err) => reject(err);
            });
        };

        const base64Image = await imgToBase64(logoARN);
        const imageId = workbook.addImage({
            base64: base64Image,
            extension: "png",
        });

        // 🔥 Definir los rangos a combinar
        const rangesToMerge = [
            { startRow: 1, endRow: 6, startCol: 1, endCol: 11 },  // A1:K6
            { startRow: 8, endRow: 11, startCol: 3, endCol: 11 }  // C8:K11
        ];

        // 🔥 Combinar celdas y aplicar bordes en un solo ciclo
        rangesToMerge.forEach(({ startRow, endRow, startCol, endCol }) => {
            worksheet.mergeCells(
                `${String.fromCharCode(64 + startCol)}${startRow}:${String.fromCharCode(64 + endCol)}${endRow}`
            );

            for (let row = startRow; row <= endRow; row++) {
                for (let col = startCol; col <= endCol; col++) {
                    let cell = worksheet.getCell(row, col);
                    cell.border = {
                        top: { style: 'thin', color: { argb: '000000' } },    // Borde superior
                        left: { style: 'thin', color: { argb: '000000' } },   // Borde izquierdo
                        bottom: { style: 'thin', color: { argb: '000000' } }, // Borde inferior
                        right: { style: 'thin', color: { argb: '000000' } }   // Borde derecho
                    };
                }
            }
        });

        // 🔥 Insertar imagen en la cabecera (fila 1)
        worksheet.addImage(imageId, {
            tl: { col: 0, row: 0 }, // 📌 Posición: primera fila
            br: { col: 4, row: 6 }, // 📌 Ocupa varias columnas
        });

        // 🔥 Insertar el título en la fila 7
        worksheet.getRow(7).height = 25; // 📏 Altura en puntos

        worksheet.mergeCells('A7:K7');
        worksheet.getCell('A7').value = 'PLAN OPERATIVO IMPLEMENTACIÓN COMPONENTE FORMACIÓN Y ACOMPAÑAMIENTO ESTRATEGIA DE SOSTENIBILIDAD';
        worksheet.getCell('A7').alignment = { horizontal: 'left', vertical: 'middle' };
        worksheet.getCell('A7').font = { bold: true, size: 14, color: { argb: 'FFFFFF' } };
        worksheet.getCell('A7').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '83ba53' } // 🎨 Código HEX sin #
        };




        // 🔥 Insertar el título proyecto

        worksheet.getCell('A8').value = `Proyecto:`;
        worksheet.getCell('A8').alignment = { horizontal: 'left', vertical: 'middle' };
        worksheet.getCell('A8').font = { size: 14 };
        worksheet.getCell('A8').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'fffaec' } // 🎨 Código HEX sin #
        };


        worksheet.getCell('B8').value = ` ${codigoInterno}`;
        worksheet.getCell('B8').alignment = { horizontal: 'left', vertical: 'middle' };
        worksheet.getCell('B8').font = { bold: true, size: 14 };


        //Insertar el avance general

        worksheet.getCell('A9').value = `Actividades Proyectadas`;
        worksheet.getCell('A9').alignment = { horizontal: 'left', vertical: 'middle' };
        worksheet.getCell('A9').font = { size: 14 };
        worksheet.getCell('A9').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'fffaec' } // 🎨 Código HEX sin #
        };


        worksheet.getCell('B9').value = parseInt(totalProyectadas);
        worksheet.getCell('B9').numFmt = '#,##0';  // ✅ Formato numérico con separadores de miles
        worksheet.getCell('B9').alignment = { horizontal: 'right', vertical: 'middle' };
        worksheet.getCell('B9').font = { bold: true, size: 14 };


        worksheet.getCell('A10').value = `Actividades Ejecutadas`;
        worksheet.getCell('A10').alignment = { horizontal: 'left', vertical: 'middle' };
        worksheet.getCell('A10').font = { size: 14 };
        worksheet.getCell('A10').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'fffaec' } // 🎨 Código HEX sin #
        };


        worksheet.getCell('B10').value = parseInt(totalEjecutadas);
        worksheet.getCell('B10').numFmt = '#,##0';  // ✅ Formato numérico con separadores de miles
        worksheet.getCell('B10').alignment = { horizontal: 'right', vertical: 'middle' };
        worksheet.getCell('B10').font = { bold: true, size: 14 };


        worksheet.getCell('A11').value = `% avance general:`;
        worksheet.getCell('A11').alignment = { horizontal: 'left', vertical: 'middle' };
        worksheet.getCell('A11').font = { size: 14 };
        worksheet.getCell('A11').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'fffaec' } // 🎨 Código HEX sin #
        };


        worksheet.getCell('B11').value = ` ${porcentajeAvance}`;
        worksheet.getCell('B11').alignment = { horizontal: 'right', vertical: 'middle' };
        worksheet.getCell('B11').font = { bold: true, size: 14 };
        worksheet.getCell('B11').value = parseFloat(porcentajeAvance) / 100; // ✅ Convertir a número y dividir entre 100
        worksheet.getCell('B11').numFmt = '0.00%';  // ✅ Formato de porcentaje con 2 decimales



        // 🔥 Aplicar bordes a las celdas de resumen
        ['A7', 'A8', 'B8', 'A9', 'B9', 'A10', 'B10', 'A11', 'B11'].forEach(cell => {
            worksheet.getCell(cell).border = {
                top: { style: 'thin', color: { argb: '000000' } },    // Borde superior negro
                left: { style: 'thin', color: { argb: '000000' } },   // Borde izquierdo negro
                bottom: { style: 'thin', color: { argb: '000000' } }, // Borde inferior negro
                right: { style: 'thin', color: { argb: '000000' } }   // Borde derecho negro
            };
        });

        // Definir los encabezados (fila 8)
        const headers = [
            'FACTOR', 'NECESIDAD', 'ACCIÓN DE FORTALECIMIENTO', 'ACTIVIDADES DERIVADAS', 'SUBACTIVIDAD',
            'TIPO DE ACTIVIDAD', 'ACTOR', 'MDV', 'No DE ACTIVIDADES', 'No DE EJECUTADAS', '% AVANCE'
        ];
        worksheet.addRow(headers).eachCell(cell => {
            cell.font = { bold: true, color: { argb: 'FFFFFF' }, size: 14 };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '0D6EFD' } // 🎨 Código HEX sin #
            };

            cell.border = {
                top: { style: 'thin', color: { argb: '000000' } },    // Borde superior negro
                left: { style: 'thin', color: { argb: '000000' } },   // Borde izquierdo negro
                bottom: { style: 'thin', color: { argb: '000000' } }, // Borde inferior negro
                right: { style: 'thin', color: { argb: '000000' } }   // Borde derecho negro
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        // Función para recorrer el JSON y extraer los datos de manera jerárquica
        const addRows = (nodes, level = 0, parentData = [], rowIndexTracker = {}) => {
            nodes.forEach(node => {
                let rowData = [...parentData];

                // 🔹 Definir la columna según el nivel
                const columnIndex = level; // FACTOR = 0, NECESIDAD = 1, etc.

                // 🔹 Si es el primer valor de esta categoría, lo registramos
                if (!rowIndexTracker[node.title]) {
                    rowIndexTracker[node.title] = worksheet.rowCount + 1;
                }

                // 🔹 Asignar título en la columna correspondiente
                rowData[columnIndex] = node.title;

                if (node.isFinal === 'yes') {
                    // 🔥 Asignamos las subactividades y detalles finales
                    rowData[4] = node.title; // Subactividad
                    rowData[5] = node.tipoActividad || ''; // Tipo de actividad
                    rowData[6] = node.actor || ''; // Actor
                    rowData[7] = node.mdv || ''; // MDV
                    rowData[8] = parseInt(node.noDeActividades) || 0; // No de actividades
                    rowData[9] = parseInt(node.noDeEjecutados) || 0; // No de ejecutados
                    rowData[10] = rowData[8] > 0 ? (rowData[9] / rowData[8]) : 0; // % Avance

                    // 🔥 Insertar la fila
                    const newRow = worksheet.addRow(rowData);

                    // 🔥 Aplicar bordes a cada celda de la fila
                    newRow.eachCell((cell) => {
                        cell.border = {
                            top: { style: 'thin', color: { argb: '000000' } },
                            left: { style: 'thin', color: { argb: '000000' } },
                            bottom: { style: 'thin', color: { argb: '000000' } },
                            right: { style: 'thin', color: { argb: '000000' } }
                        };
                    });

                } else {
                    // 🔥 Llamado recursivo para los hijos
                    addRows(node.children || [], level + 1, rowData, rowIndexTracker);
                }
            });
        };

        // 🔹 Fusionar celdas donde los valores son repetidos
        const mergeRepeatedCells = () => {
            for (let col = 1; col <= 4; col++) { // FACTOR (A) -> ACTIVIDAD DERIVADA (D)
                let prevRow = null;
                let startRow = null;
                let currentValue = null;

                for (let row = 9; row <= worksheet.rowCount; row++) { // Desde la fila 9
                    const cellValue = worksheet.getCell(row, col).value;

                    if (cellValue && cellValue === currentValue) {
                        // 🔥 Fusionamos si es el mismo valor
                        if (!startRow) startRow = prevRow;
                    } else {
                        if (startRow && prevRow && startRow !== prevRow) {
                            worksheet.mergeCells(startRow, col, prevRow, col);

                            // 🔥 Aplicar formato de alineación y estilos
                            const mergedCell = worksheet.getCell(startRow, col);
                            mergedCell.alignment = {
                                horizontal: 'left',  // ✅ Centrado horizontalmente
                                vertical: 'middle',    // ✅ Centrado verticalmente
                                wrapText: true         // ✅ Texto ajustado dentro de la celda
                            };


                        }
                        startRow = null;
                        currentValue = cellValue;
                    }
                    prevRow = row;
                }

                // 🔹 Si hay un bloque final sin fusionar, fusionarlo
                if (startRow && prevRow && startRow !== prevRow) {
                    worksheet.mergeCells(startRow, col, prevRow, col);
                }
            }
        };


        // Iniciar el recorrido desde los factores (nivel 1)
        // 🔥 Ejecutar la función después de agregar los datos
        if (jsonData.length > 0 && jsonData[0].children) {
            addRows(jsonData[0].children, 0, []);
            mergeRepeatedCells(); // ✅ Fusiona los valores repetidos en columnas clave
        }

        // 🔥 Aplicar formato de porcentaje a la columna % Avance
        worksheet.getColumn(11).numFmt = '0.00%'; // ✅ Esto muestra 70% en vez de 0.7000

        // Ajustar ancho de las columnas
        worksheet.columns.forEach(column => {
            column.width = 30;
        });

        // Guardar el archivo
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'Plan_Operativo.xlsx');
    };

    return (
        <Button type="primary" onClick={exportToExcel} icon={<FileExcelOutlined />}>
            Exportar
        </Button>
    );
};

export default ExportExcelComponent;
